export enum PurchaseOrderStatusEnum {
  DRAFT = "DRAFT",
  PRICED = "PRICED",
  APPROVED = "APPROVED",
  PURCHASED = "PURCHASED",
  PARTIALLY_RECEIVED = "PARTIALLY_RECEIVED",
  RECEIVED = "RECEIVED",
  CANCELLED = "CANCELLED",
}

export const CANCELLABLE_PURCHASE_ORDER_STATUSES: readonly PurchaseOrderStatusEnum[] = [
  PurchaseOrderStatusEnum.PRICED,
  PurchaseOrderStatusEnum.APPROVED,
  PurchaseOrderStatusEnum.PURCHASED,
  PurchaseOrderStatusEnum.PARTIALLY_RECEIVED,
  PurchaseOrderStatusEnum.RECEIVED,
] as const;

export const PURCHASE_ORDER_UNCANCEL_STATUS = PurchaseOrderStatusEnum.PRICED;

export const ARCHIVABLE_PURCHASE_ORDER_STATUSES: readonly PurchaseOrderStatusEnum[] = [
  PurchaseOrderStatusEnum.RECEIVED,
  PurchaseOrderStatusEnum.CANCELLED,
] as const;

export const getPurchaseOrderStatusLabel = (status: PurchaseOrderStatusEnum): string => {
  switch (status) {
    case PurchaseOrderStatusEnum.DRAFT:
      return "BORRADOR";
    case PurchaseOrderStatusEnum.PRICED:
      return "VALORADO";
    case PurchaseOrderStatusEnum.APPROVED:
      return "APROBADO";
    case PurchaseOrderStatusEnum.PURCHASED:
      return "COMPRADO";
    case PurchaseOrderStatusEnum.PARTIALLY_RECEIVED:
      return "PARCIALMENTE RECIBIDO";
    case PurchaseOrderStatusEnum.RECEIVED:
      return "RECIBIDO";
    case PurchaseOrderStatusEnum.CANCELLED:
      return "ANULADO";
  }
};

export const getPurchaseOrderStatusActionLabel = (status: PurchaseOrderStatusEnum): string => {
  switch (status) {
    case PurchaseOrderStatusEnum.DRAFT:
      return "Devolver a borrador";
    case PurchaseOrderStatusEnum.PRICED:
      return "Marcar como valorado";
    case PurchaseOrderStatusEnum.APPROVED:
      return "Aprobar";
    case PurchaseOrderStatusEnum.PURCHASED:
      return "Marcar como comprado";
  }
};

export const getPurchaseOrderStatusOptions = (): { label: string; value: string }[] =>
  Object.keys(PurchaseOrderStatusEnum).map((val) => {
    const value = PurchaseOrderStatusEnum[val as keyof typeof PurchaseOrderStatusEnum];
    return { label: getPurchaseOrderStatusLabel(value), value: value, translate: true };
  });

export function getPurchaseOrderNextStatus(status: PurchaseOrderStatusEnum): PurchaseOrderStatusEnum {
  switch (status) {
    case PurchaseOrderStatusEnum.DRAFT:
      return PurchaseOrderStatusEnum.PRICED;
    case PurchaseOrderStatusEnum.PRICED:
      return PurchaseOrderStatusEnum.APPROVED;
    case PurchaseOrderStatusEnum.APPROVED:
      return PurchaseOrderStatusEnum.PURCHASED;
    case PurchaseOrderStatusEnum.PURCHASED:
      return PurchaseOrderStatusEnum.DRAFT;
  }
}

export function canCancelPurchaseOrder(status: PurchaseOrderStatusEnum): boolean {
  return CANCELLABLE_PURCHASE_ORDER_STATUSES.includes(status);
}

export function canArchivePurchaseOrder(status: PurchaseOrderStatusEnum): boolean {
  return ARCHIVABLE_PURCHASE_ORDER_STATUSES.includes(status);
}
